import React from "react";

import { Grid } from "@material-ui/core";

import { exactLength, onlyNumbers, required } from "../../../helpers/validations/validators";
import { CboLocalidades } from "../../cbos/CboLocalidades";
import { ValidatorInputField } from "../../atomic/atoms/Inputs";
import { ValidatedDate } from "../../atomic/atoms/DatePicker";

const TYPES = {
    TEXT: 1,
    NUMBER: 2,
    DATE: 3,
    SELECT: 4,
}

export const DatosTitularTraslado = ({formValues, setFormValues, disabled}) => {
    const afiliado = formValues.afiliado;

    const getAge = () => {
        if (!afiliado.fecha_nacimiento) return;
        const today = new Date();
        const birthDate = new Date(afiliado.fecha_nacimiento);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleChange = (value) => {
        setFormValues({
            afiliado: {
                ...formValues.afiliado,
                domiciliosAfiliados: {
                    ...formValues.afiliado.domiciliosAfiliados,
                    ...value
                }
            }
        })
    }

    return (
        <Grid container spacing={2}>
            {[
                {
                    size: 2,
                    label: "Nro Afiliado",
                    type: TYPES.TEXT,
                    value: afiliado.carnet,
                    disabled: disabled
                },
                {
                    size: 4,
                    label: "Nombre y Apellido",
                    type: TYPES.TEXT,
                    value: afiliado.apellido_y_nombre,
                    disabled: disabled
                },
                {
                    size: 3,
                    label: "Fecha de Nacimiento",
                    type: TYPES.DATE,
                    value: afiliado.fecha_nacimiento,
                    disabled: disabled
                },
                {
                    size: 3,
                    label: "Edad",
                    type: TYPES.TEXT,
                    value: `${getAge()} AÑOS`,
                    disabled: disabled
                },
                {
                    size: 6,
                    label: "Email",
                    type: TYPES.TEXT,
                    validations: [required],
                    value: afiliado.domiciliosAfiliados.mail,
                    onChange: ({target}) => handleChange({ mail: target.value }),
                    disabled
                },
                {
                    size: 3,
                    label: "Tel. Particular (10 dígitos sin el 0)",
                    type: TYPES.NUMBER,
                    validations: [required, onlyNumbers, exactLength(10)],
                    value: afiliado.domiciliosAfiliados.telefono,
                    onChange: ({target}) => { if(target.value.length <= 10) handleChange({ telefono: target.value }) },
                    disabled
                },
                {
                    size: 3,
                    label: "Tel. Celular (10 dígitos sin el 0 ni 15)",
                    type: TYPES.NUMBER,
                    validations: [required, onlyNumbers, exactLength(10)],
                    value: afiliado.domiciliosAfiliados.celular,
                    onChange: ({target}) => { if(target.value.length <= 10) handleChange({ celular: target.value }) },
                    disabled
                },
                {
                    size: 6,
                    label: "Calle",
                    type: TYPES.TEXT,
                    value: afiliado.domiciliosAfiliados.calle,
                    disabled: disabled
                },
                {
                    size: 1,
                    label: "Nro",
                    type: TYPES.NUMBER,
                    value: afiliado.domiciliosAfiliados.nro,
                    disabled: disabled
                },
                {
                    size: 2,
                    label: "Codigo Postal",
                    type: TYPES.NUMBER,
                    value: afiliado.domiciliosAfiliados.codigo_postal,
                    disabled: disabled
                },
                {
                    size: 3,
                    label: "Localidad",
                    type: TYPES.SELECT,
                    value: afiliado.domiciliosAfiliados.id_localidad,
                    disabled: disabled
                },
            ].map(({ label, type, value, size, validations = [], onChange = false, disabled }, index) => (
                <Grid item xs={12} md={size} key={index}>
                    {(type === TYPES.TEXT || type === TYPES.NUMBER) && (
                        <ValidatorInputField
                            variant="standard"
                            label={label}
                            value={value}
                            margin="normal"
                            onChange={onChange ? onChange : () => {}}
                            validations={validations}
                            type={type === TYPES.NUMBER ? "number" : "text"}
                            disabled={!onChange || disabled}
                        />
                    )}
    
                    {type === TYPES.DATE && (
                        <ValidatedDate
                            style={{ padding: "0 0.5em" }}
                            value={value}
                            label={label}
                            onChange={() => {}}
                            fullWidth
                            margin="normal"
                            validations={[required]}
                            disabled
                        />
                    )}
                    
                    {type === TYPES.SELECT && (
                        <CboLocalidades
                            name="domiciliosAfiliados.id_localidad"
                            cp={afiliado.domiciliosAfiliados.codigo_postal ? afiliado.domiciliosAfiliados.codigo_postal : 0}
                            valor={afiliado.domiciliosAfiliados.id_localidad}
                            disabled={true}
                            notRequired={true}
                            manejadorInputChange={() => {}}
                        />
                    )}
                </Grid>
            ))}
        </Grid>
    );
};
